import { render, staticRenderFns } from "./policy-links.vue?vue&type=template&id=728d55f9&scoped=true&"
import script from "./policy-links.vue?vue&type=script&lang=js&"
export * from "./policy-links.vue?vue&type=script&lang=js&"
import style0 from "./policy-links.vue?vue&type=style&index=0&id=728d55f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d55f9",
  null
  
)

export default component.exports